import * as tslib_1 from "tslib";
import { ESRI } from '../esri-loader-util';
import * as i0 from "@angular/core";
var TooltipService = /** @class */ (function () {
    function TooltipService() {
    }
    TooltipService.prototype.setupMapImageLayerPopupTemplate = function (layer) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var fieldInfo, _a, PopupTemplate, popupTemplate;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        fieldInfo = this.getDynamicfieldInfos(layer.mapcoreProps);
                        return [4 /*yield*/, Promise.all([ESRI.PopupTemplate])];
                    case 1:
                        _a = tslib_1.__read.apply(void 0, [_b.sent(), 1]), PopupTemplate = _a[0];
                        popupTemplate = new PopupTemplate({
                            title: layer.sublayers.toArray()[0].title,
                            content: [{
                                    type: 'fields',
                                    fieldInfos: fieldInfo
                                }]
                        });
                        layer.sublayers.toArray().reduce(function (prev, curr) {
                            if (curr.mapcoreProps && !prev.some(function (l) { return l.mapcoreProps && l.mapcoreProps === curr.mapcoreProps; })) {
                                return tslib_1.__spread(prev, [curr]);
                            }
                            return prev;
                        }, []).forEach(function (subLayer) {
                            subLayer.popupTemplate = popupTemplate;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    TooltipService.prototype.setupFeatureLayerPopupTemplate = function (layer) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var fieldInfo, _a, PopupTemplate;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        fieldInfo = this.getFeatureLayerFieldInfos(layer.fields);
                        return [4 /*yield*/, Promise.all([ESRI.PopupTemplate])];
                    case 1:
                        _a = tslib_1.__read.apply(void 0, [_b.sent(), 1]), PopupTemplate = _a[0];
                        layer.popupTemplate = new PopupTemplate({
                            title: layer.title,
                            content: [{
                                    type: 'fields',
                                    fieldInfos: fieldInfo
                                }]
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    TooltipService.prototype.setupGraphicsLayerPopupTemplate = function (layer) {
        if (layer.graphics.length > 0 && layer.graphics.items[0].geometry.type.toLowerCase() === 'point') {
            if (layer.graphics.items[0].attributes === null) {
                layer.graphics.items[0].attributes = {
                    latitude: layer.graphics.items[0].geometry.latitude,
                    longitude: layer.graphics.items[0].geometry.longitude
                };
            }
            else {
                layer.graphics.items[0].attributes.latitude = layer.graphics.items[0].geometry.latitude;
                layer.graphics.items[0].attributes.longitude = layer.graphics.items[0].geometry.longitude;
            }
            layer.graphics.items[0].popupTemplate = {
                title: layer.title,
                content: [{
                        type: 'fields',
                        fieldInfos: [{
                                fieldName: 'latitude',
                                label: 'Latitude'
                            }, {
                                fieldName: 'longitude',
                                label: 'Longitude'
                            }]
                    }],
                visible: layer.visible
            };
        }
    };
    TooltipService.prototype.setPopupTemplateVisibility = function (layer) {
        switch (layer.type) {
            case 'map-image':
                if (layer.sublayers.length > 0) {
                    if (layer.sublayers.items[0].popupTemplate !== null) {
                        layer.sublayers.forEach(function (subLayer) {
                            if (subLayer.popupTemplate) {
                                subLayer.popupTemplate.visible = layer.visible;
                            }
                        });
                    }
                    else {
                        this.setupMapImageLayerPopupTemplate(layer);
                    }
                }
                break;
            case 'feature':
                if (layer.popupTemplate !== null) {
                    layer.popupTemplate.visible = layer.visible;
                }
                else {
                    this.setupFeatureLayerPopupTemplate(layer);
                }
                break;
            case 'graphics':
                if (layer.graphics.items[0].popupTemplate !== null) {
                    layer.graphics.items[0].popupTemplate = layer.visible;
                }
                else {
                    this.setupGraphicsLayerPopupTemplate(layer);
                }
                break;
            default:
                break;
        }
    };
    TooltipService.prototype.getDynamicfieldInfos = function (mapcoreProps) {
        var e_1, _a;
        var hoverColumns = mapcoreProps.hoverColumnList ? mapcoreProps.hoverColumnList.split(',').map(function (item) { return item.trim(); }) : [];
        var fieldInfoJson = [];
        var _loop_1 = function (hoverColumn) {
            var column = mapcoreProps.columns.find(function (obj) { return obj.name === hoverColumn; });
            fieldInfoJson.push({
                fieldName: hoverColumn,
                label: column ? (column.alias ? column.alias : column.name) : hoverColumn
            });
        };
        try {
            for (var hoverColumns_1 = tslib_1.__values(hoverColumns), hoverColumns_1_1 = hoverColumns_1.next(); !hoverColumns_1_1.done; hoverColumns_1_1 = hoverColumns_1.next()) {
                var hoverColumn = hoverColumns_1_1.value;
                _loop_1(hoverColumn);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (hoverColumns_1_1 && !hoverColumns_1_1.done && (_a = hoverColumns_1.return)) _a.call(hoverColumns_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return fieldInfoJson;
    };
    TooltipService.prototype.getFeatureLayerFieldInfos = function (fields) {
        if (fields === void 0) { fields = []; }
        var e_2, _a;
        var fieldInfoJson = [];
        if (fields) {
            try {
                for (var fields_1 = tslib_1.__values(fields), fields_1_1 = fields_1.next(); !fields_1_1.done; fields_1_1 = fields_1.next()) {
                    var field = fields_1_1.value;
                    fieldInfoJson.push({
                        fieldName: field.name,
                        label: field.alias
                    });
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (fields_1_1 && !fields_1_1.done && (_a = fields_1.return)) _a.call(fields_1);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
        return fieldInfoJson;
    };
    TooltipService.ngInjectableDef = i0.defineInjectable({ factory: function TooltipService_Factory() { return new TooltipService(); }, token: TooltipService, providedIn: "root" });
    return TooltipService;
}());
export { TooltipService };
